import { faAt } from '@fortawesome/pro-light-svg-icons';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    useMediaQuery,
    Button,
    InputAdornment,
    TextField,
} from '@mui/material';

import UserActionCreator from '../../actions/UserActionCreator';
import isValidEmail from '../../core/typeguards/isValidEmail';
import { MAIN_PATH } from '../../models/Paths';
import ResourceService from '../../services/i18n';
import NotificationActionCreator from '../../services/Notifications/actions/NotificationActionCreator';
import ActivityIndicator from '../ActivityIndicator';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import Icon from '../Icon';
import Modal from '../Modal';
import lock from '../../assets/images/icons/lock.png';
import useTranslation from 'services/i18n/core/useTranslation';

export interface IForgotPasswordModalProps {
    open: boolean;
}

export const ForgotPasswordModal = (props: IForgotPasswordModalProps) => {
    const [email, setEmail] = useState<string>('');

    const [isLoading, setLoading] = useState<boolean>(false);

    // const { NOT_VALID_EMAIL, EMPTY_EMAIL_INPUT, EMPTY_PASSWORD_INPUT } = useTranslation(
    //     'EMPTY_EMAIL_INPUT',
    //     'EMPTY_PASSWORD_INPUT',
    //     'NOT_VALID_EMAIL'
    // );

    const { open } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const translation = useTranslation();

    const handleForgotPassword = useCallback(async () => {
        if (email === '') {
            const { EMPTY_EMAIL_INPUT } = ResourceService.getCurrentResources('EMPTY_EMAIL_INPUT');
            //Alert.alert('Zurücksetzen fehlgeschlagen!', EMPTY_EMAIL_INPUT);
            dispatch(
                NotificationActionCreator.enqueueSnackbar({
                    key: String(new Date().getTime() + Math.random()),
                    message: EMPTY_EMAIL_INPUT,
                    options: { variant: 'error' },
                })
            );
            setEmail('');
        } else {
            if (isValidEmail(email)) {
                // TODO: send the password change request
                setLoading(true);
                await dispatch(UserActionCreator.forgotPassword(email, 'a8O2cGVrbGVyZGVuIGthw6dhcmtlbiBkw7zF'));
                setLoading(false);
                setEmail('');
                // setPassword('');
                //Alert.alert('Zurücksetzen erfolgreich!', DIALOG_PASSWORD_CHANGEREQUEST);
                dispatch(
                    NotificationActionCreator.enqueueSnackbar({
                        key: String(new Date().getTime() + Math.random()),
                        message: translation.DIALOG_PASSWORD_CHANGEREQUEST,
                        options: { variant: 'success' },
                    })
                );
            } else {
                const { WRONG_EMAIL } = ResourceService.getCurrentResources('WRONG_EMAIL');
                //Alert.alert('Zurücksetzen fehlgeschlagen!', WRONG_EMAIL);
                dispatch(
                    NotificationActionCreator.enqueueSnackbar({
                        key: String(new Date().getTime() + Math.random()),
                        message: WRONG_EMAIL,
                        options: { variant: 'error' },
                    })
                );
                // setPassword('');
                setEmail('');
            }
        }
    }, [email, dispatch]);

    const handleClose = () => history.push(MAIN_PATH);

    const handleEnter = async (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !e.ctrlKey && !e.shiftKey) {
            await handleForgotPassword();
        }
    };
    const isDesktop = useMediaQuery('(min-width:500px)', { defaultMatches: true });
    return (
        <Dialog onClose={handleClose} open={open} scroll="body">
            <DialogContent>
                <IconButton onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }}>
                    <Icon icon={faTimes} />
                </IconButton>
                <div className="flex justify-content-center" style={{ marginBottom: '20px' }}>
                    <img src={lock} alt="forgot password" />
                </div>
                <Typography variant="h6">{translation.LOGIN_FORGOT_PASSWORD}</Typography>
                <form id="forgot-password-form" autoComplete="forgotPassword" onSubmit={(e) => e.preventDefault()} className="flex column no-grow">
                    <TextField
                        id="email"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.currentTarget.value)}
                        onKeyPress={handleEnter}
                        autoComplete="email"
                        placeholder={translation.LOGIN_EMAIL_INPUT}
                        fullWidth
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleForgotPassword}
                        className="spacing double margin top"
                        type="submit"
                    >
                        {translation.PASSWORD_BUTTON}
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default ForgotPasswordModal;
